
CheckoutV2.Cart = function( checkout ) {
	var cart = this;

	this.saved = true;
	this.items = {};

	this.shipping = new CheckoutV2.Cart.Shipping(checkout, cart);
	this.totals = new CheckoutV2.Cart.Totals(checkout, cart);
	this.shipping.init();

	this.Item = CheckoutV2.Cart.Item;
	
	if (checkout.config.promoCodeEnabled) {
		this.promos = new CheckoutV2.Cart.Promotions(checkout, cart);
	}
	
	if (checkout.config.saveForLater) {
		this.savedItems = {};
		this.saveForLater = new CheckoutV2.Cart.SaveForLater(checkout, cart);
	}

	this.$v2Wrapper = $('.checkout-v2');
	this.$wrap = $('#scartwrapper');
	this.$cShopping = $('.js-cshopping', cart.$v2Wrapper);
	this.$cartContentWrapper = $('.js-cart-wrap', cart.$v2Wrapper);
	
	this.$loadingOverlay = $('#cart-loading-overlay', cart.$v2Wrapper);
	this.$loadingMsg = $('.msg-text', cart.$loadingOverlay);
	this.$emptyCart = $('.empty-cart', cart.$v2Wrapper);
    this.$reviewContentWrapper = $('.js-review.js-cart-wrap');
    this.$reviewContentWrapperError = this.$reviewContentWrapper.find('#cart-error');
    this.$reviewContentWrapperErrorMsg = this.$reviewContentWrapperError.find('.msg-text');
    this.$reviewContentWrapperErrorClose = this.$reviewContentWrapperError.find('.close');
	
	//if (checkout.config.isEndeca) {
	//	this.$cartContentWrapper = $('.cartcontentwrapper');
	//}
	
	this.$error = $('.js-cart-error', cart.$v2Wrapper);
	this.$errorMsg = $('.msg-text', cart.$error);
	this.$errorClose = $('.close', cart.$error);
	this.$warning = $('.js-cart-warning', cart.$v2Wrapper);
	this.$warningMsg = $('.msg-text', cart.$warning);
	this.$warningClose = $('.close', cart.$warning);
	this.$info = $('.js-cart-info', cart.$v2Wrapper);
	this.$infoMsg = $('.msg-text', cart.$info);
	this.$infoClose = $('.close', cart.$info);
	
	//this.$itemTpl = $('#cart-item-tpl');
	//this.$itemMoreInfoRowTpl = $('#cart-item-moreinfo-row-tpl');
	this.$itemContainer = $( '.js-cart-contents .js-product-tiles' );
	this.$reviewItemContainer = $( '.js-review .js-product-tiles' );
	
	this.$linkToCart = $('#ltcart', cart.$v2Wrapper);
	this.$cartLinkModal = $('.js-cart-link-modal');
	this.$cartLink = $('.js-cart-link', cart.$cartLinkModal);
	this.$copyCartBtn = $('.js-copy-cart-link-btn', cart.$cartLinkModal);
	this.$cartLinkAlert = $('.js-cart-link-alert', cart.$cartLinkModal);
	
	this.$clearCart = $('#ccart');
	this.$textCart = $('#textcart');
	//this.$sidebar = $('#cart-sidebar');
	
	this.$stepControls = $('#cart-step-controls');
	//this.$proceed = $('#cart-proceed');
	this.$addWishList = $('#addwishlist');
	this.$showSuggestions = $('#showSuggestions');
	this.$emailCart = $('.js-email-cart', cart.$v2Wrapper);
	this.$showEmailCart = $('#showEmailCart', cart.$v2Wrapper);
	this.$carSweepstakesBanner = $('#carSweepstakesBanner');
	this.$switchCheckout = $('#checkout-switch-select');
	this._shipETA = '';
	this.usePoETA = false;

    Object.defineProperty(this, 'shipETA', {
        get: function() {
            return this._shipETA;
        },
        set: function(gid) {
            this._shipETA = gid;
        }});

	this.po_shipETA = '';
	
	this.$cartLinks = $('.cart-links');
	this.$myCartFooter = $('.my-cart .section-footer');
	this.$orderSummary = $('.order-summary', cart.$v2Wrapper);
	
	this.$importCustomerCart = $('.js-import-cart');

	this.listrakIndex = 1;
	this.listrakItemsString = "";

	this.init = function() {

		cart.listen();

		if (!checkout.currentStepName())
			checkout.session.set({
				'step': 'cart'
			});

		// kick-off
		// check if we need to use PO ETAs for (non-US or willcall/instore shipping)
		cart.usePoETA = false;
		if (checkout.session.get('shipping.country') && checkout.session.get('shipping.country') !== 'US') {
			cart.usePoETA = true;
			checkout.shippingServiceGroupID = undefined;
			checkout.session.set({'shippingServiceGroupSet':false});
			if (checkout.session.get('shippingServiceCode')) {
				checkout.shippingServiceCode = checkout.session.get('shippingServiceCode');
				checkout.session.set({'shippingServiceSet': true});
			}
		}

		if (!cart.usePoETA && !checkout.session.get('shippingServiceSet') && checkout.config.instoreShippingGroups[ checkout.session.get('shippingServiceGroupID') ] == 1) {
			cart.usePoETA = true;
			checkout.shippingServiceGroupID = checkout.session.get('shippingServiceGroupID')
			checkout.shippingServiceCode = undefined;
			checkout.session.set({'shippingServiceSet': false, 'shippingServiceCode': undefined });
			checkout.session.set({'shippingServiceGroupSet': true});
		}
		if (!cart.usePoETA && !checkout.session.get('shippingServiceGroupSet') && checkout.session.get('shippingServiceCode')  && checkout.config.instoreShippingServices[ checkout.session.get('shippingServiceCode') ] == 1) {
			cart.usePoETA = true;
			checkout.shippingServiceCode = checkout.session.get('shippingServiceCode');
			checkout.shippingServiceGroupID = undefined;
			checkout.session.set({'shippingServiceSet': true});
			checkout.session.set({'shippingServiceGroupSet':false, 'shippingServiceGroupID': undefined});
		}
		cart.getItems(cart.usePoETA);
	};

	this.listen = function() {

		cart.$textCart.on('click', function(e){
			e.preventDefault();
			cart.showTextCart();
		});
		
		cart.$addWishList.on('click', function(e){
			e.preventDefault();
			cart.addAllToWishList();
		});

		cart.$clearCart.click(cart.clear);

		cart.$showEmailCart.click(cart.showEmailCart);

		cart.$linkToCart.on('click', function(e){
			e.preventDefault();
			cart.linkToCart();
		});
		cart.$cartLinkModal.on('shown.bs.modal', function(e){
			cart.selectCartLink();
		});
		cart.$copyCartBtn.on('click', function(e){
			e.preventDefault();
			cart.copyCartLink();
		});
		
		$('.js-cshop').on('click', function(e){ // tied to page header link and empty cart button
			e.preventDefault();
            var thisURL = new URL( window.location.href );
            var referrerURL = new URL( document.referrer );

            // make sure we don't send them to a different website
            if ( thisURL.hostname === referrerURL.hostname ) {
			    window.location.href = referrerURL.toString();
            }
            else {
                window.location.href = "/";
            }
		});
		
		// cart-item event listeners (cloned when added)
		$('.my-cart').on('click', '.removeCartItem', function() {
			cart.getItemFromInput($(this)).remove();
		});

		$('.my-cart').on('change', '.cart-item-qty', function() {
			var $el = $(this),
				item = cart.getItemFromInput($el),
				qty = (parseInt($el.val()) || 0);
			
			item.changeQty(qty);
		});
		$('.my-cart').on('input propertychange', '.cart-item-qty', function() {
			var $el = $(this);
			checkout.delayChange($el, (Modernizr.touch ? 3000 : 2000), function() {
				$el.blur();
			});
		});
		$('.my-cart').on('focus', '.cart-item-qty', function() {
			var myEsNum = $(this).parents('.product-tile').children('.product-info').find('.esnum').text().trim();
			if (myEsNum == '2710386' || myEsNum == '3047848') {
				$(this).siblings('.vgcTooltip').stop().fadeIn('fast', function(){
					var $this = $(this);
					$this.siblings('.cart-item-qty').animate({'background-color' : '#F54857'},300, function(){
						$this.delay(4000).fadeOut(1500, function(){
							$this.siblings('.cart-item-qty').animate({'background-color' : '#fff'},300);
						});
					});
				});
			}
		});
		
		$('.my-cart').on('click', '.cart-item-remove-yes', function() {
			cart.getItemFromInput($(this)).confirmRemove(true);
		});

		$('.my-cart').on('click', '.cart-item-remove-no', function() {
			cart.getItemFromInput($(this)).confirmRemove(false);
		});

		$('.my-cart').on('change', '.cart-item-price-edit select', function() {
			cart.getItemFromInput($(this)).changePrice('select');
		});

		$('.my-cart').on('input propertychange', '.cart-item-price-edit input', function() {
			var $el = $(this);
			checkout.delayChange($el, 1000, function() {
				$el.blur();
			});
		});
		$('.my-cart').on('change', '.cart-item-price-edit input', function() {
			cart.getItemFromInput($(this)).changePrice('input');
		});
		
		$('.my-cart').on('click', '.moreInfo', function() {
			cart.getItemFromInput($(this)).toggleMoreInfo();
		});

		cart.$switchCheckout.change( function(e) {
			checkout.switchCheckoutVersion( e.target.value );
		});
		
		cart.$loadingOverlay.on('animationend webkitAnimationEnd MSAnimationEnd', function(e) {
			var $this = cart.$loadingOverlay;
			if ($this.hasClass('fade-out')) $this.hide();
		});
		
		cart.$warningClose.on('click', function(){
			cart.warning(false);
		});
		
		cart.$errorClose.on('click', function(){
			cart.error(false);
		});
		
		cart.$infoClose.on('click', function(){
			cart.info(false);
		});
		
		cart.$importCustomerCart.on('click', function(){
			cart.importCustomerCart();
		});
	};

	this.getItems = function(usePoETA) {

		cart.loading('Loading Cart Contents');
		var options = { isV2Checkout: checkout.config.isV2Checkout };
		if(typeof usePoETA !== 'undefined')
			options.usePoETA = usePoETA;
		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getItems',
				'options': encodeURIComponent(JSON.stringify( options ))
			}
		})
		.done(function(response) {
			$.each(response.data, function(i, itemResponse) {
				var cartItem = new cart.Item( checkout, cart );
                cartItem.add( itemResponse, usePoETA );
			});
			
			if (response.warning && response.warning.length) {
				cart.error(response.warning.join('<br />'));
			}
			
			if (response.notice && response.notice.length) {
				cart.error(response.notice.join('<br />'));
			}
			
			if (response.info && response.info.length) {
				cart.info( cart.formatMessage(response.info, '<br/>', true) );
			}
			
			if (Object.keys(cart.items).length){

				cart.toggleHasContents(true);
				cart.loading(false);
				cart.totals.calc(true);

				checkout.suggestions.show();
				
				seenSuggestions = true;
				
				if (checkout.config.shipDate.enabled) {
					cart.setShipDate(response);
				}
				
				if (checkout.config.promoCodeEnabled) {
					cart.promos.validateCart();
				}

			} else {
				cart.toggleHasContents(false);
				cart.loading(false);
			}

            cart.sendToListrak();
		})
		.fail(function(request) {
			var errorMsg = checkout.remote.getErrorMsg(request);

			if (errorMsg) {
				cart.toggleHasContents(false);
				cart.loading(false);
				cart.error('Retrieving Cart Contents Failed');
			}

			$("#shipFloatText b").html([
                '<br>There was an error processing your order ETA.<br> <br>',
                'Please refresh the page or contact ',
                '<a style="color:#b60209; cursor:pointer; background: none; border: 0;display: inline; margin-right: 0; padding:0 ;position: relative;transition:none;width:auto;" ',
                    ' href="mailto:' + checkout.config.contactInfo.email + '">',
                    checkout.config.contactInfo.email,
                '</a>',
            ].join(''));

		});
	};

    this.checkAutoWishList = function() {
        if(window.location.search.match(/\batwl=1\b/)) cart.$addWishList.click();
    };

	// Show the Email My Cart modal
	this.showEmailCart = function(e) {
		// without this the google recaptcha will not work in a bootstrap modal in IE 8-11
		// bootstrap modal's enforceFocus function prevents focusing on the recaptcha in IE
		// see
		// https://jsfiddle.net/emilhem/Lgovn28f/2/ a jsfiddle showing the issue
		// http://stackoverflow.com/a/28965638 stackoverflow answer with the code below
		// http://fiddle.jshell.net/Lgovn28f/10/ jsfiddle from above edited with the code from
		// stackoverflow, which now works
		if (e)
			e.preventDefault();
		$.fn.modal.Constructor.prototype.enforceFocus = function () { };
		if ( checkout.session.isLoggedIn() ) {
			var emailAddress = checkout.session.get('billing.email');
			cart.$emailCart.find("#targetEmail").val(emailAddress);

			cart.$emailCart.find('#ca-div').hide();
		} else {
			cart.$emailCart.find('#ca-div').show();
		}
		emailCartRecaptchaReset(); // emailCart modal
		cart.$emailCart.modal("show");
	};

	this.$emailCart.find('#ca').click( function(e) {
		var caClicked = cart.$emailCart.find("#ca:checked").length;
		if (caClicked == 1)
			cart.$emailCart.find('#newaccountdetails').show();
		else
			cart.$emailCart.find('#newaccountdetails').hide();
	});

	this.$emailCart.find("#cta-email-cart").click(function(e) {
		e.preventDefault();
		$("#sendingEmailErrorMsg").html('');
		var $sendBtn = $(this);
		$sendBtn.prop('disabled', true);
		$("#sendingEmailProgress").show();

		var err = validateEmailCart(cart.$emailCart);

		if ( err ) {
			$sendBtn.prop('disabled', false);
			$("#sendingEmailErrorMsg").html(err);
			$("#sendingEmailProgress").hide();
			return false;
		}
		var emailCartData = {
			'step'			: 'cart',
			'action'		: 'emailCart',
			'email'			: cart.$emailCart.find("#targetEmail").val().trim(),
			'password'		: cart.$emailCart.find('#targetPassword').val().trim(),
			'zip'			: cart.$emailCart.find('#targetZip').val().trim(),
			'ca'			: cart.$emailCart.find("#ca:checked").length,
			'response'		: cart.$emailCart.find('.js-recaptcha-token').val().trim(),
		};

		if (checkout.user) {
			emailCartData.user = checkout.user;
		}

		checkout.remote.call({
			'data': emailCartData
		})
			.done(function(response) {
				$sendBtn.prop('disabled', false);
				cart.$emailCart.modal("hide");
				// reset fields
				$("#sendingEmailProgress").hide();
				$("#sendingEmailErrorMsg").html('');
				$('#ca').attr('checked', false );
				$('#targetPassword').val('');
				$('#targetZip').val('');
				$('#newaccountdetails').hide();
				$(window).unbind('beforeunload');
			})
			.fail(function(request) {
				$sendBtn.prop('disabled', false);

				var errorMsg = checkout.remote.getErrorMsg(request);

				$("#sendingEmailProgress").hide();

				if (errorMsg) {
					$("#sendingEmailErrorMsg").html(errorMsg);
					emailCartRecaptchaReset(); // emailCart modal
				}
			});
	});

	this.$emailCart.find(".close").click(function(e) {
		$("#sendingEmailProgress").hide();
		$("#sendingEmailErrorMsg").html('');
		$('#ca').attr('checked', false );
		$('#targetPassword').val('');
		$('#targetZip').val('');
		$('#newaccountdetails').hide();
	});

	// Show the text cart page.
	// This will build a JSON object with all of the data needed to populate the text cart page.  The JSON object
	// will be passed as a URL parameter to the text cart page.
	this.showTextCart = function() {
		var cartItems = [];

		// Loop through the cart and get the product data for each item.
		$(".my-cart.js-cart-contents .product-tile").each(function(i, obj) {
			var $this = $(this);
			var description = $this.find(".cleanDesc").html();
			var brand = $this.find(".product-details img").attr("alt");
			
			var shippingDisplay = $this.find(".product-price .ship-status").text();
			var freeShipping = "";
			if(shippingDisplay == "Free Shipping") {
				freeShipping = "Free Shipping";
			}
			var freeShippingEligible = "";
			if(shippingDisplay.indexOf("on orders") >= 0) {
				freeShippingEligible = "Free Shipping";
			}

			var esNumber = $this.find(".esnum").html();
			var partNumber = $this.find(".mfgnum").text();
			var qty = $this.find(".cart-item-qty").val();
			var unitPrice = $this.find(".price-total").attr('data-unit-cost');
			var extPrice = $this.find(".price-total").html();
			extPrice = extPrice.replace('$','');
			var $stockStatusEl = $this.find(".product-details .ship-status");
			var inStock = '';
			if ($stockStatusEl.length) {
				inStock = $stockStatusEl.html();
			}

			// We only want the end of the message.
			inStock = inStock.replace("If Ordered Now, ","");
			if(inStock == 'Ships Today') {
				inStock = 'In Stock';
			}
			cartItems.push({description: description,
					   brand: brand,
					   freeShipping: freeShipping,
					   freeShippingEligible: freeShippingEligible,
					   esNumber: esNumber,
					   partNumber: partNumber,
					   qty: qty,
					   unitPrice: unitPrice,
					   extPrice: extPrice,
					   inStock: inStock});
		});

		// Get the values from the cart totals section.
		var subTotal = $(".order-total #cart-subtotal").html();
		subTotal = subTotal.replace('$','');
		var shipping = $(".order-total #cart-shipping").html();
		shipping = shipping.replace('$','');
		shipping = shipping.replace('FREE','0.00');
		var salesTax = $(".order-total #cart-tax").html();
		salesTax = salesTax.replace('$','');
		var cartTotal = $(".order-total #cart-total").html();
		cartTotal = cartTotal.replace('$','');
		
		var taxExempt = $(".order-total #cart-tax-exempt").is(":checked");

		var totals = {subTotal: subTotal,
					  shipping: shipping,
					  salesTax: salesTax,
					  cartTotal: cartTotal,
					  taxExempt: taxExempt};

		// Build the link to the cart.
		var link = {linkToCart: cart.buildLinkToCart()};

		var parms = {cart: cartItems,
					 totals: totals,
					 link: link};

		// Format the URL parameter, create a form and submit it.
		var parameters="?parms="+encodeURIComponent(JSON.stringify(parms));
		var form = document.createElement('form');

		var formInput = '<input type="hidden" value="" id="parameters" name="parameters"></input>';

		// Workaround for Cross-Site Request Forgery
		if(typeof csrfParamName !== 'undefined') {
			formInput += '<input type="hidden" name="' + csrfParamName + '" value="' + csrfID + '" ></input>';
		}

		form.innerHTML = formInput;
		document.body.appendChild(form);
		$("#parameters").val(encodeURIComponent(JSON.stringify(parms)));
		form.method = "post";
		form.action = fixNavState("/Cart/Text/");
		form.submit();
	};

	// called after customer login
	this.checkItems = function(updateCart, qtyChanged, poETA, instoreETA, settings) {

		cart.loading('Updating Cart Contents');
		cart.totals.loading('Updating Cart Contents');
		// if (checkout.shipping)
		//	checkout.shipping.loading('Updating Cart Contents');

		var options = { 'isV2Checkout': checkout.config.isV2Checkout };
		options['usePoETA'] = (poETA || instoreETA) ? true : false;
		$.extend(options, settings || {} );

		if (typeof poETA == 'undefined' && typeof instoreETA == 'undefined')
			delete options.poETA;

		return checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'getItems',
				'options': encodeURIComponent(JSON.stringify( options ) ),
			}
		})
		.done(function(response) {
			if (response.data && response.data.length > 0) {
				cart.updateItems(response, null, poETA || instoreETA, 1);
				if (checkout.config.shipDate.enabled) {
					cart.setShipDate(response);
				}
				if (updateCart) {
					if (qtyChanged) {
						cart.totals.calc(true);
					} else {
						cart.totals.update('cart');
					}
				}
				if (response.info && response.info.length) {
					cart.info( cart.formatMessage(response.info, '<br/>', true) );
					//step to cart if items were added
					checkout.nextStep( true, 0 );
					cart.shipping.calc( true, false );
					
				}
                // need to send cart to listrak on login
			    if (cart && cart.sendToListrak)
				    cart.sendToListrak();
			} else {
				cart.toggleHasContents(false);
			}
		})
		.always(function() {
			cart.loading(false);
		})
		.fail(function() {
			if (checkout.config.shipDate.enabled) {
				$(checkout.config.shipDate.target).html("There was an error processing your order ETA. Please refresh the page or contact <a href='"+checkout.config.contactInfo.email+"'>"+checkout.config.contactInfo.email+"</a>");
			}
		});
	};

    this.setShipDate = function(response) {
        var latestETA = '';
        var po_latestETA = '';
        var hasDirectShip = false;
        var backOrdered = false;
        var po_backOrdered = false;
		
		if (response) {
			$.each(response.data, function(i, itemResponse) {
				if (itemResponse.item.stockStatus.indexOf("Back Ordered") >= 0) {
					backOrdered=true;
					checkout.cart.shipETA = 'Back Ordered';
				} else if (itemResponse.item.stockStatus.indexOf("Direct Ship") >= 0) { // ignore direct ship for ETA
					hasDirectShip=true;
				}
				if ( !backOrdered && ( !latestETA || (itemResponse.item.ETA > latestETA) ) ) {
					latestETA = itemResponse.item.ETA;
					checkout.cart.shipETA = latestETA;
				}
				if (hasDirectShip) {
					if (itemResponse.item.po_stockStatus.indexOf("Back Ordered") >= 0) {
						checkout.cart.po_shipETA = 'Back Ordered';
						po_backOrdered=true;
					}
					if ( !po_backOrdered && ( !po_latestETA || (itemResponse.item.po_ETA > po_latestETA) ) ) {
						po_latestETA = itemResponse.item.po_ETA;
						checkout.cart.po_shipETA = po_latestETA;
					}
				} else {
						checkout.cart.po_shipETA = checkout.cart.shipETA;
				}
				
			});
		} else { // use cart.items after remove item
			$.each(cart.items, function(i, item) {
				if (item.data.stockStatus.indexOf("Back Ordered") >= 0) {
					backOrdered=true;
					checkout.cart.shipETA = 'Back Ordered';
				} else if (item.data.stockStatus.indexOf("Direct Ship") >= 0) { // ignore direct ship for ETA
					hasDirectShip=true;
				}
				if ( !backOrdered && ( !latestETA || (item.data.ETA > latestETA) ) ) {
					latestETA = item.data.ETA;
					checkout.cart.shipETA = latestETA;
				}
			});
		}
		
		var message = { msgPrefix: '', shipETA: '', msgSuffix: '' };
		
		if( (!backOrdered) && (latestETA) ) {
			message.msgPrefix = 'Your current projected ship date is ';
			message.shipETA = isoDateFormatter(latestETA, true, true) + '.';
			message.msgSuffix = ' We only ship complete orders.';
		}
		else if (backOrdered) {
			message.shipETA = 'Back Ordered items: Product ETA Unknown.'
			message.msgSuffix = ' We only ship complete orders.';
		}
		if(hasDirectShip) {
			if (message.shipETA) {
				message.msgPrefix = '';
				message.shipETA = 'This order will ship from multiple locations. Shipping transit times vary by location.';
				message.msgSuffix = '';
			} else {
				message.shipETA = "Direct Ship from supplier: ETA will vary.";
			}
		}
		
		if (checkout.config.shipDate.enabled && ( message.msgPrefix || message.shipETA ) ) {
			$('.my-cart .section-footer').html( Jemplate.process('includes/partials/ship_date.html', { shipCode: (message.msgPrefix + message.shipETA + message.msgSuffix) } ) );
		}
    };

	this.updateItems = function(response, warningMsg, poETA, skipStep) {
		var scrollToCart = false;

		$.each(response.data, function(i, itemResponse) {

			if (itemResponse.infos.length)
				scrollToCart = true;

			var item = cart.items[itemResponse.item.cartItemKey];

			if (item)
				item.update(itemResponse, itemResponse.infos, poETA, skipStep);
			else
				new cart.Item(checkout, cart).add(itemResponse);

		});

		if (response.warning.length) {
			scrollToCart = true;
			cart.error(response.warning.join('<br />'))
		}

		if (response.notice.length) {
			scrollToCart = true;
			cart.error(response.notice.join('<br />'))
		}

		if (warningMsg) {
			scrollToCart = true;
			cart.warning(warningMsg);
		}

		if (scrollToCart && !skipStep) {
			cart.totals.calc(true);
			$('html,body').animate(
				{ 'scrollTop': checkout.cart.$cartContentWrapper.offset().top },
				500
			);
		} else {
			cart.totals.update('cart');
		}
	};

	this.clear = function() {

		cart.error(false);
		cart.warning(false);
		cart.loading('Clearing Cart Contents');

		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'clear'
			}
		})
		.done(function() {
			cart.items = {};
			cart.toggleStepControls();
			cart.toggleHasContents(false);
			cart.totals.updateNumItems();
			$('.my-cart .product-tile').remove();
            cart.sendToListrak();
		})
		.fail(function(request) {
			var errorMsg = checkout.remote.getErrorMsg(request);
			alert('Error clearing cart contents' + ((errorMsg) ? ': '+errorMsg : ''));
		})
		.always(function() {
			cart.loading(false);
		});

	};

	this.toggleHasContents = function(hasContents) {
		if (hasContents) {
			cart.$cartLinks.show();
			cart.$myCartFooter.show();
			cart.$orderSummary.show();
			cart.$emptyCart.hide();
			cart.$itemContainer.removeClass('product-tiles-shrink');
			cart.$reviewItemContainer.removeClass('product-tiles-shrink');
			//cart.$cartContentWrapper.show();
			cart.$cShopping.show();
			cart.$addWishList.show();

            if( checkout.shipping && (checkout.step != 0 || checkout.user) ) checkout.shipping.$wrap.show();
			
			//cart.$linkToCart.show();
			//cart.$clearCart.show();
			//cart.$sidebar.show();
			//if (checkout.config.isEndeca) {
			//	cart.$cartContentWrapper.show();
			//}
			
			
            //cart.$carSweepstakesBanner.show();

            //cart.checkAutoWishList();

			//if (checkout.user)
			//	cart.$textCart.show();

		} else {
			//checkout.session.set({
			//	'step': 'cart',
			//	'shippingOverride': null,
			//	'shippingOverrideAmt': null,
			//	'taxExempt': null,
			//	'alt_ship_notes': null
			//});

			cart.$cartLinks.hide();
			cart.$myCartFooter.hide();
			cart.$orderSummary.hide();
			cart.$reviewItemContainer.addClass('product-tiles-shrink');
			cart.$itemContainer.addClass('product-tiles-shrink');
			cart.$emptyCart.show();
			//cart.$cartContentWrapper.hide();
			cart.$cShopping.hide();
			cart.$addWishList.hide();

            if( checkout.shipping ) checkout.shipping.$wrap.hide();
			
			//cart.$linkToCart.hide();
			//cart.$clearCart.hide();
			//cart.$textCart.hide();
			//cart.$sidebar.hide();
			
			//if (checkout.config.isEndeca) {
			//	cart.$cartContentWrapper.hide();
			//}
			
			//$('.topBmlBtn').hide();
			
			//$(window).unbind('beforeunload');
            //cart.$carSweepstakesBanner.hide();

			//if (checkout.shipping)
			//	checkout.shipping.$wrap.hide();

			//if (checkout.login && checkout.login.$wrap)
			//	checkout.login.$wrap.hide();

			//if (checkout.billship && checkout.billship.$wrap)
			//	checkout.billship.$wrap.hide();

			//if (checkout.payment)
			//	checkout.payment.hide();
		}
	};

	this.loading = function(loadingMsg) {
		if (loadingMsg) {
			cart.$loadingMsg.html(loadingMsg);
			//cart.$loadingOverlay.show();
			cart.$loadingOverlay.show().removeClass('fade-out').addClass('fade-in');
			//checkout.alignMiddle(cart.$loadingOverlay.find('.msg'), cart.$loadingOverlay);
			this.clearMessages();
		} else {
			cart.$loadingOverlay.removeClass('fade-in').addClass('fade-out');
			//cart.$loadingOverlay.hide();
		}
	};

	this.error = function(errorMsg) {
		if (errorMsg) {
			var currentMsg = cart.$errorMsg.html();

			if (currentMsg) {
				cart.$errorMsg.html(this.cleanMessages(currentMsg, '<br />', errorMsg));
			} else {
				cart.$errorMsg.html(errorMsg);
			}

			cart.$error.show();

		} else {
			cart.$error.hide();
			cart.$errorMsg.html('');
		}
	};

    this.myCartError = function(errorMsg) {
        if (errorMsg) {
            var currentMsg = cart.$reviewContentWrapperErrorMsg.html();

            if (currentMsg)
                cart.$reviewContentWrapperErrorMsg.html(this.cleanMessages(currentMsg, '<br />', errorMsg));
            else
                cart.$reviewContentWrapperErrorMsg.html(errorMsg);

            cart.$reviewContentWrapperError.show();

        } else {
            cart.$reviewContentWrapperError.hide();
            cart.$reviewContentWrapperErrorMsg.html('');
        }
    };

	this.warning = function(warningMsg) {
		if (warningMsg) {
			var currentMsg = cart.$warningMsg.html();

			if (currentMsg) {
				cart.$warningMsg.html(this.cleanMessages(currentMsg, '<br />', warningMsg));
			} else {
				cart.$warningMsg.html(warningMsg);
			}

			cart.$warning.show();

		} else {
			cart.$warning.hide();
			cart.$warningMsg.html('');
		}
	};
	
	this.info = function(infoMsg) {
		if (infoMsg) {
			var currentMsg = cart.$infoMsg.html();

			if (currentMsg) {
				cart.$infoMsg.html(this.cleanMessages(currentMsg, '<br />', infoMsg));
			} else {
				cart.$infoMsg.html(infoMsg);
			}

			cart.$info.show();

		} else {
			cart.$info.hide();
			cart.$infoMsg.html('');
		}
	};

	this.linkToCart = function() {
		cart.$cartLink.html(cart.buildLinkToCart());
		cart.$cartLinkModal.modal('show');
	};

	this.buildLinkToCart = function() {

		var queryParts = [];

		var i = 1;
		for (var cartItemKey in cart.items) {
			queryParts.push(
				'add'+i+'=' + cart.items[cartItemKey].data.productID,
				'qty'+i+'=' + cart.items[cartItemKey].data.qty
			);
            if(cart.items[cartItemKey].data.pdk) {
                queryParts.push('pdk'+i+'='+cart.items[cartItemKey].data.pdk);
            }
			i++;
		}

		queryParts.push(
			'utm_source=' + checkout.user,
			'utm_medium=email',
			'utm_content=link2cart'
		);

		if (checkout.user)
			queryParts.push(
				'salesrep=' + checkout.user
			);

     return document.URL.split('/',3).join('/')
     + fixNavState('/Cart/') + '?'
     + queryParts.join('&');

	};
	
	this.selectCartLink = function() {
		var range = document.createRange();
		var selection = window.getSelection();
		range.selectNodeContents($('.js-cart-link')[0]);
		selection.removeAllRanges();
		selection.addRange(range);
	};
	
	this.copyCartLink = function() {
		cart.selectCartLink();
		document.execCommand("Copy");
		cart.$cartLinkAlert.show();
		window.setTimeout(function() {
			cart.$cartLinkModal.modal('hide');
			cart.$cartLinkAlert.hide();
		}, 5000);
	};

	//this.toggleLinkToCart = function() {
	//	/* This code centers the link to cart popover under link to cart. .popover is a class associated with bootstrap.
	//	Unless the bootstraps behaviors are addressed after the scope is properly determined there is a risk affecting elements that are not intended to have the same behavior.
	//	Hence the localized targeting.  This is not ideal solution to this issue, but the best available solution at the moment. */
	//	var popoverWidth = cart.$linkToCart.siblings('.popover').width();
	//	var positionLeft = cart.$linkToCart.position().left;
	//	var positionTop = cart.$linkToCart.position().top;
	//	var height = cart.$linkToCart.outerHeight();
	//	var width = cart.$linkToCart.outerWidth();
	//	var targetCenter = (positionLeft + (width / 2) - 215 );
	//	var targetBottom = (positionTop + height);
	//
    //    var $popover = cart.$linkToCart.data( checkout.config.bsPopoverData );
    //    var $tip;
    //    if( $popover.$tip ) $tip = $popover.$tip;
    //    else                $tip = $( $popover.getTipElement() );
	//
	//	if ( $tip.prev().length)
	//		cart.$linkToCart.popover('hide');
	//	else {
	//		cart.$linkToCart.popover('show');
	//		if (checkout.config.isEndeca) {
	//			cart.$linkToCart.siblings('.popover').css('position','absolute');
	//			cart.$linkToCart.siblings('.popover').css('left', targetCenter );
	//			cart.$linkToCart.siblings('.popover').css('top', targetBottom );
	//		}
	//
	//		var $textArea = $tip.find('textarea');
	//
	//		$textArea
	//			.click(function() {
	//				$textArea.select();
	//			})
	//			.select();
	//	}
	//};

	this.getItemData = function() {
		var data = {};

		for (var cartItemKey in cart.items)
			data[cartItemKey] = cart.items[cartItemKey].data.qty

		return data;
	};

    this.containsProductID = function(findProductID) {

        for (var cartItemKey in cart.items) {
            if (cart.items[cartItemKey].productID == findProductID) {
                return true;
            }
        }

        return false;
    }

	this.toggleStepControls = function(force) {

		// if force is applied, use it
		if (arguments.length) {
			if (force)
				return cart.$stepControls.show();
			else
				return cart.$stepControls.hide();
		}

		var show = true;

		if (!Object.keys(cart.items).length)
			show = false;
		else if (checkout.currentStepName() != 'cart')
			show = false;
		else if (
			cart.shipping
			&& cart.shipping.errorMsg
		)
			show = false;

		if (show)
			cart.$stepControls.show();
		else
			return cart.$stepControls.hide();

	}

	this.validate = function() {
		/* TODO: any validation needed? */
		//if (cart.shipping.getValidateErrors().length)
		//	return false;

		return true;
	};

	this.proceed = function() {
		var errors = cart.shipping.getValidateErrors();

		if (errors.length) {
			cart.shipping.showValidateErrors(errors);
			return false;
		}

		//cart.toggleStepControls(false);
		//cart.$cShopping.hide();
		//$('.topBmlBtn').hide();

		//if (!checkout.shipping)
		//	checkout.shipping = new Checkout.Shipping(checkout);

		//checkout.shipping.buildContent();
		//checkout.shipping.stepTo();
		
		return true;
	};

	this.addAllToWishList = function() {
		// Add a hidden "input.qty" for each item so that they
		// will be picked up by findQtys()

		var pdkQtys = {};

		$(".my-cart.js-cart-contents .product-tile").each(function() {
			var $this = $(this);
			var productID = $this.find(".esnum").text();
			var qty = $this.find(".cart-item-qty").val().replace(/\D/, "");
			var pdk = $this.find(".cart-item-pdk").text();
			var obj = {};

			try {
				qty = parseInt(qty, 10);
			}
			catch(e) {
				return;
			}

			if(qty > 0) {
				if( !(pdkQtys[productID]) ) {
					pdkQtys[productID] = new Array();
				}
				if (pdk) {
					obj.pdk = pdk;
				}
				obj.qty = qty;
			}
			pdkQtys[productID].push(obj);
		});

		window.getWishListProds = function() {
			return pdkQtys;
		}

		addToWishList();
	}

    this._sendToListrak = function() {
        if(typeof _ltk == "undefined") return;

        // if there isn't anything in the cart, clear it
        var itemCount = Object.keys( this.items ).length;
        if(itemCount == 0) {
            this.listrakItemsString = "";
            _ltk.SCA.ClearCart();
            return;
        }

        // Get the first part of the URL, without the path
        var baseURL = window.location.href.split('/')[ 2 ];

        // otherwise send the contents to listrak
        var queryParts = [];
        var i = 0;

        var listrakItems = [];
        $.each(this.items, function(cartitemID, item) {
            var imageURL = CDNpath + '/img/bg_no-image_100x75.jpg';
            if(item.data.mainImage) {
                imageURL = CDNproduct + '/' + item.data.mainImage + '_x300.jpg';
            }

            // Add the default product landing page
            var productURL = item.data.canonicalPath;

            /*
             * _ltk.SCA.AddItemWithLinks('<productID>', <quantity>,
             *                           '<price>', '<productName>',
             *                           '<productImageUrl>', '<productUrl>')
            */

            ++ i;
            queryParts.push( "add" + i + "=" + item.data.productID );
            queryParts.push( "qty" + i + "=" + item.data.qty );
            if(item.data.pdk) {
                queryParts.push( "pdk" + i + "=" + item.data.pdk );
            }
            _ltk.SCA.AddItemWithLinks(
                item.data.pretty_partnumber,
                item.data.qty,
                item.data.availablePricing.retail,
                item.data.clean_description,
                imageURL,
                productURL /* , 😢 */
            );

            listrakItems.push([
                item.data.qty,
                item.data.availablePricing.retail,
                item.data.clean_description,
                imageURL,
                productURL
            ]);
        });
        var queryString = queryParts.join("&");
        // if this cart matches the previous cart sent, reset the cart and return
        var listrakItemsString = JSON.stringify( listrakItems );
        if (listrakItemsString == this.listrakItemsString) {
            _ltk.SCA.Reset();
            return;
        }
        this.listrakItemsString = listrakItemsString;
        _ltk.SCA.CartLink = baseURL + "/Cart/?" + queryString;
        _ltk.SCA.Submit();
    };

    /* use listrak's async manager to keep multiple
       instances of _sendToListrak from running simultaneously,
       queue them up, make them dependent on the previous
       iteration completing */
    this.sendToListrak = function() {
        if(typeof _ltk == "undefined") return;
        if(typeof _ltk_util == "undefined") return;

        // default waitFors for an ltk_util.reeady call
        var waitFor = ["jQuery","_ltk","sessionLoad"];
        var ltkIndex = this.listrakIndex++;
        // wait for all of listrak's currently queued tasks, as well as the ones
        // we added to the queue
        _ltk_util.AsyncManager.Calls.forEach(function(call) {
            waitFor.push(call.Name);
        });
        // LTK Util AsyncManager.StartAsyncCall( name, function, timeout, async calls to wait for );
        _ltk_util.AsyncManager.StartAsyncCall( "_checkout_submit_"+ltkIndex, function() {
            checkout.cart._sendToListrak();
        }, null, waitFor );
    };


	// Util
	this.getItemFromInput = function($el) {
		var cartItemKey = $el.parents('.product-tile').attr('id').replace('cart-item-', '');
		return cart.items[cartItemKey];
	};
	
	this.getSavedItemFromInput = function($el) {
		var savedItemKey = $el.parents('.product-tile').attr('id').replace('saved-item-', '');
		return cart.savedItems[savedItemKey];
	};
	
	this.clearMessages = function() {
		this.error();
		this.warning();
	};
	
	this.cleanMessages = function(oldMsgStr, separator, newMsg) { // return unique messages
		var hashSet = {};
		oldMsgStr.split(separator).forEach(function (msg){
			if (!(hashSet[msg])) {
				hashSet[msg] = true;
			}
		});
		if (!(hashSet[newMsg])) {
			hashSet[newMsg] = true;
		}
		return Object.keys(hashSet).join(separator);
	};
	
	this.formatMessage = function(messages, separator, skipHTML) {
		separator = (separator !== undefined) ? separator : '<br/>';
		skipHTML = (skipHTML !== undefined) ? skipHTML : false;
		var msg = '';
		for (var i = 0; i < messages.length; i++) {
			if (skipHTML && messages[i].startsWith('<') && messages[i].endsWith('>')) {
				msg += messages[i];
			} else {
				msg += messages[i] + separator;
			}
		}
		return msg;
	};
	
	this.importCustomerCart = function() {
		checkout.remote.call({
			'data': {
				'step': 'cart',
				'action': 'importCustomerCart',
			}
		})
		.done(function(response) {
			if (response.data.success) {
				window.location.reload();
			} else if (response.data.message) {
				alert(response.data.message);
			} else {
				alert('There was an error importing the cart');
			}
		})
		.fail(function(request) {
			alert('There was an error importing the cart');
		});
	};

	this.init();
	
};
